<template>
  <div class="rule-config">
    <el-card>
      <div slot="header" class="card-header">
        <span>规则配置</span>
        <el-button type="primary" size="small" @click="handleAdd">
          <i class="el-icon-plus"></i> 添加规则
        </el-button>
      </div>

      <el-table :data="ruleList" border style="width: 100%" v-loading="loading">
        <el-table-column prop="id" label="ID" width="80"></el-table-column>
        <el-table-column prop="name" label="规则名称" width="180"></el-table-column>
        <el-table-column prop="deviceId" label="适用设备" width="130">
          <template slot-scope="scope">
            {{ getDeviceName(scope.row.deviceId) }}
          </template>
        </el-table-column>
        <el-table-column prop="condition" label="触发条件" min-width="200">
          <template slot-scope="scope">
            {{ formatCondition(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column prop="action" label="执行动作" width="120">
          <template slot-scope="scope">
            {{ getActionName(scope.row.action) }}
          </template>
        </el-table-column>
        <el-table-column prop="enabled" label="状态" width="100">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.enabled"
              active-color="#13ce66"
              inactive-color="#ff4949"
              @change="handleToggle(scope.row)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="180" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="text" @click="handleTest(scope.row)">测试</el-button>
            <el-button size="mini" type="text" class="danger-text" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.size"
        :total="pagination.total"
        layout="total, sizes, prev, pager, next, jumper"
        style="margin-top: 20px; text-align: right;"
      >
      </el-pagination>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="700px" @close="handleDialogClose">
      <el-form :model="ruleForm" :rules="ruleRules" ref="ruleForm" label-width="120px">
        <el-form-item label="规则名称" prop="name">
          <el-input v-model="ruleForm.name" placeholder="请输入规则名称"></el-input>
        </el-form-item>
        <el-form-item label="适用设备" prop="deviceId">
          <el-select v-model="ruleForm.deviceId" placeholder="请选择设备" style="width: 100%;" @change="handleDeviceChange">
            <el-option label="所有设备" value="all"></el-option>
            <el-option
              v-for="device in devices"
              :key="device.id"
              :label="device.name"
              :value="device.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="触发条件" required>
          <el-col :span="8">
            <el-form-item prop="condition.field">
              <el-select v-model="ruleForm.condition.field" placeholder="选择变量">
                <el-option
                  v-for="variable in deviceVariables"
                  :key="variable.id"
                  :label="variable.variableName"
                  :value="variable.variableId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item prop="condition.operator">
              <el-select v-model="ruleForm.condition.operator" placeholder="运算符">
                <el-option label=">" value="gt"></el-option>
                <el-option label="<" value="lt"></el-option>
                <el-option label="=" value="eq"></el-option>
                <el-option label=">=" value="gte"></el-option>
                <el-option label="<=" value="lte"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="condition.value">
              <el-input-number v-model="ruleForm.condition.value" :min="0" placeholder="阈值"></el-input-number>
            </el-form-item>
          </el-col>
        </el-form-item>
        <el-form-item label="延时时间" v-if="ruleForm.action === 'control'">
          <el-input-number v-model="ruleForm.delayTime" :min="0" :max="3600" placeholder="延时时间(秒)"></el-input-number>
        </el-form-item>
        <el-form-item label="执行动作" prop="action">
          <el-select v-model="ruleForm.action" placeholder="请选择执行动作" style="width: 100%;">
            <el-option label="发送告警" value="alarm"></el-option>
            <el-option label="发送通知" value="notify"></el-option>
            <el-option label="自动控制" value="control"></el-option>
            <el-option label="记录日志" value="log"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="通知方式" v-if="ruleForm.action === 'notify'">
          <el-checkbox-group v-model="ruleForm.notifyTypes">
            <el-checkbox label="sms">短信</el-checkbox>
            <el-checkbox label="email">邮件</el-checkbox>
            <el-checkbox label="wechat">微信</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="告警级别" v-if="ruleForm.action === 'alarm'">
          <el-radio-group v-model="ruleForm.alarmLevel">
            <el-radio label="critical">紧急</el-radio>
            <el-radio label="warning">严重</el-radio>
            <el-radio label="info">一般</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="ruleForm.remark" type="textarea" :rows="2" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from '@/api'

export default {
  name: 'RuleConfig',
  data() {
    return {
      ruleList: [],
      devices: [],
      deviceVariables: [],
      loading: false,
      pagination: {
        page: 1,
        size: 10,
        total: 0
      },
      dialogVisible: false,
      dialogTitle: '添加规则',
      ruleForm: {
        id: null,
        name: '',
        deviceId: '',
        condition: {
          field: '',
          operator: '',
          value: null
        },
        action: '',
        delayTime: 0,
        notifyTypes: [],
        alarmLevel: 'warning',
        remark: '',
        enabled: true
      },
      ruleRules: {
        name: [{ required: true, message: '请输入规则名称', trigger: 'blur' }],
        deviceId: [{ required: true, message: '请选择设备', trigger: 'change' }],
        'condition.field': [{ required: true, message: '请选择变量', trigger: 'change' }],
        'condition.operator': [{ required: true, message: '请选择运算符', trigger: 'change' }],
        'condition.value': [{ required: true, message: '请输入阈值', trigger: 'blur' }],
        action: [{ required: true, message: '请选择执行动作', trigger: 'change' }]
      }
    }
  },
  mounted() {
    this.fetchRules()
    this.fetchDevices()
  },
  methods: {
    async fetchRules() {
      this.loading = true
      try {
        const params = {
          page: this.pagination.page,
          size: this.pagination.size
        }
        const res = await api.getRules(params)
        this.ruleList = res.data || []
        this.pagination.total = res.total || 0
      } catch (error) {
        this.ruleList = []
        this.pagination.total = 0
        this.$message.error('获取规则列表失败')
      } finally {
        this.loading = false
      }
    },
    async fetchDevices() {
      try {
        const res = await api.getDevices({ size: 100 })
        this.devices = res.data || []
      } catch (error) {
        this.devices = []
        this.$message.error('获取设备列表失败')
      }
    },
    async fetchDeviceVariables(deviceId) {
      if (!deviceId || deviceId === 'all') {
        this.deviceVariables = []
        return
      }
      try {
        const res = await api.getDeviceVariables(deviceId)
        this.deviceVariables = res.data || []
      } catch (error) {
        this.deviceVariables = []
        this.$message.error('获取设备变量失败')
      }
    },
    handleDeviceChange() {
      this.fetchDeviceVariables(this.ruleForm.deviceId)
      this.ruleForm.condition.field = ''
    },
    getDeviceName(deviceId) {
      if (deviceId === 'all') return '所有设备'
      const device = this.devices.find(d => d.id === deviceId)
      return device ? device.name : deviceId
    },
    getActionName(action) {
      const map = {
        alarm: '发送告警',
        notify: '发送通知',
        control: '自动控制',
        log: '记录日志'
      }
      return map[action] || action
    },
    formatCondition(rule) {
      const operatorMap = {
        gt: '>',
        lt: '<',
        eq: '=',
        gte: '>=',
        lte: '<='
      }
      const variable = this.deviceVariables.find(v => v.variableId === rule.condition.field)
      const field = variable ? variable.variableName : rule.condition.field
      const operator = operatorMap[rule.condition.operator] || rule.condition.operator
      return `${field} ${operator} ${rule.condition.value}`
    },
    handleSearch() {
      this.pagination.page = 1
      this.fetchRules()
    },
    handleReset() {
      this.handleSearch()
    },
    handleSizeChange(val) {
      this.pagination.size = val
      this.fetchRules()
    },
    handleCurrentChange(val) {
      this.pagination.page = val
      this.fetchRules()
    },
    handleAdd() {
      this.dialogTitle = '添加规则'
      this.ruleForm = {
        id: null,
        name: '',
        deviceId: '',
        condition: {
          field: '',
          operator: '',
          value: null
        },
        action: '',
        delayTime: 0,
        notifyTypes: [],
        alarmLevel: 'warning',
        remark: '',
        enabled: true
      }
      // 刷新设备列表
      this.fetchDevices()
      this.deviceVariables = []
      this.dialogVisible = true
    },
    handleEdit(row) {
      this.dialogTitle = '编辑规则'
      this.ruleForm = JSON.parse(JSON.stringify(row))
      // 刷新设备列表
      this.fetchDevices()
      // 获取设备变量
      if (row.deviceId) {
        this.fetchDeviceVariables(row.deviceId)
      } else {
        this.deviceVariables = []
      }
      this.dialogVisible = true
    },
    handleTest(row) {
      this.$message.info(`正在测试规则: ${row.name}`)
    },
    handleDelete(row) {
      this.$confirm(`确定要删除规则 "${row.name}" 吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$message.success('删除成功')
        this.fetchRules()
      }).catch(() => {})
    },
    handleToggle(row) {
      this.$message.success(`${row.name}已${row.enabled ? '启用' : '禁用'}`)
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$message.success(this.ruleForm.id ? '编辑成功' : '添加成功')
          this.dialogVisible = false
          this.fetchRules()
        }
      })
    },
    handleDialogClose() {
      this.$refs.ruleForm.resetFields()
    }
  }
}
</script>

<style scoped>
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.danger-text {
  color: #F56C6C;
}
</style>
